import { LegalLayout, LegalSection } from "@/components/nuit/LegalLayout";

export default function MentionsLegales() {
  return (
    <LegalLayout title="Mentions légales" updated="Juin 2026">
      <LegalSection n="01" title="Éditeur du site">
        <p>
          Le site <strong className="text-white/80">nuitcalme.eu</strong> et le
          programme NUIT CALME sont édités par&nbsp;:
        </p>
        <p>
          <strong className="text-white/80">MBSYNAPSE</strong>
          <br />
          Programme digital de bien-être et d’hygiène du sommeil « NUIT CALME »
          <br />
          Adresse e-mail&nbsp;:{" "}
          <a
            href="mailto:contact@nuitcalme.eu"
            className="text-[#e8c97a] hover:underline"
          >
            contact@nuitcalme.eu
          </a>
          <br />
          Site web&nbsp;: nuitcalme.eu
        </p>
        <p>
          Le directeur de la publication est le représentant légal de MBSYNAPSE.
        </p>
      </LegalSection>

      <LegalSection n="02" title="Hébergement">
        <p>
          Le site est hébergé par <strong className="text-white/80">Emergent</strong>{" "}
          (plateforme d’hébergement et de déploiement d’applications web).
        </p>
        <p>
          Pour toute question relative à l’hébergement, vous pouvez écrire à
          l’adresse&nbsp;:{" "}
          <a href="mailto:support@emergent.sh" className="text-[#e8c97a] hover:underline">
            support@emergent.sh
          </a>
          .
        </p>
      </LegalSection>

      <LegalSection n="03" title="Propriété intellectuelle">
        <p>
          L’ensemble des contenus présents sur le site et dans le programme NUIT
          CALME (textes, guides PDF, exercices, enregistrements audio, ambiances
          sonores, éléments graphiques, logo, charte visuelle et code) sont la
          propriété exclusive de MBSYNAPSE et sont protégés par le droit de la
          propriété intellectuelle.
        </p>
        <p>
          Toute reproduction, représentation, modification, publication ou
          adaptation de tout ou partie de ces éléments, par quelque moyen que ce
          soit, sans l’autorisation écrite préalable de MBSYNAPSE, est interdite
          et constituerait une contrefaçon sanctionnée par le Code de la propriété
          intellectuelle. Les contenus acquis sont réservés à un usage strictement
          personnel et non commercial.
        </p>
      </LegalSection>

      <LegalSection n="04" title="Données personnelles (RGPD)">
        <p>
          Conformément au Règlement Général sur la Protection des Données
          (RGPD - UE 2016/679) et à la loi « Informatique et Libertés », MBSYNAPSE
          s’engage à protéger la vie privée des utilisateurs.
        </p>
        <p>
          Les données collectées (prénom, adresse e-mail, informations de commande)
          servent uniquement à la gestion des commandes, à l’accès au programme et,
          avec votre consentement, à l’envoi d’informations et de conseils liés à
          NUIT CALME. Les paiements sont traités par notre prestataire{" "}
          <strong className="text-white/80">Stripe</strong>&nbsp;; MBSYNAPSE ne
          stocke aucune donnée bancaire.
        </p>
        <p>
          Vous disposez d’un droit d’accès, de rectification, d’effacement, de
          portabilité et d’opposition sur vos données. Pour exercer ces droits,
          écrivez à{" "}
          <a
            href="mailto:contact@nuitcalme.eu"
            className="text-[#e8c97a] hover:underline"
          >
            contact@nuitcalme.eu
          </a>
          . Vous pouvez également introduire une réclamation auprès de la CNIL
          (www.cnil.fr).
        </p>
      </LegalSection>

      <LegalSection n="05" title="Cookies">
        <p>
          Le site peut déposer des cookies techniques nécessaires à son bon
          fonctionnement ainsi que, le cas échéant, des cookies de mesure
          d’audience. Les cookies strictement nécessaires ne requièrent pas votre
          consentement&nbsp;; les autres ne sont déposés qu’après votre accord.
        </p>
        <p>
          Vous pouvez à tout moment configurer votre navigateur pour refuser ou
          supprimer les cookies. Le refus des cookies techniques peut toutefois
          limiter certaines fonctionnalités du site.
        </p>
      </LegalSection>

      <LegalSection n="06" title="Nature du service">
        <p>
          NUIT CALME est un programme de bien-être et d’hygiène du sommeil. Il ne
          constitue en aucun cas un dispositif médical, un traitement ou un avis
          médical, et ne remplace pas la consultation d’un professionnel de santé.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
